/**
 * Account-scoped local storage helpers for stock image source settings.
 */

const AUTH_ACCOUNT_KEY = 'pb:auth-account:v1';

function safeStorage() {
  try {
    return globalThis.localStorage || null;
  } catch {
    return null;
  }
}

function readAccountSub() {
  const storage = safeStorage();
  if (!storage) return '';
  try {
    const parsed = JSON.parse(storage.getItem(AUTH_ACCOUNT_KEY) || '{}');
    const sub = typeof parsed?.sub === 'string' ? parsed.sub.trim() : '';
    return sub && sub !== 'admin' ? sub : '';
  } catch {
    return '';
  }
}

function scopedKey(baseKey) {
  const sub = readAccountSub();
  return sub ? `${baseKey}:${sub}` : baseKey;
}

export function getStoredValue(baseKey) {
  const storage = safeStorage();
  if (!storage || !baseKey) return '';
  const key = scopedKey(baseKey);
  const scoped = storage.getItem(key);
  if (scoped) return scoped;

  if (key !== baseKey) {
    const legacy = storage.getItem(baseKey) || '';
    if (legacy) {
      storage.setItem(key, legacy);
      storage.removeItem(baseKey);
      return legacy;
    }
  }

  return '';
}

export function setStoredValue(baseKey, value) {
  const storage = safeStorage();
  if (!storage || !baseKey) return;
  const key = scopedKey(baseKey);
  const next = String(value || '').trim();
  if (next) storage.setItem(key, next);
  else {
    storage.removeItem(key);
    if (key !== baseKey) storage.removeItem(baseKey);
  }
}

export function removeStoredValue(baseKey) {
  const storage = safeStorage();
  if (!storage || !baseKey) return;
  storage.removeItem(scopedKey(baseKey));
}
